<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">{{ isEdicao ? 'Editar Linha de Produto' : 'Nova Linha de Produto' }}
                        </h1>
                        <p class="welcome-message">
                            <button mat-icon-button (click)="voltar()">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Preencha os dados abaixo para {{ isEdicao ? 'editar' : 'cadastrar' }} a linha de produto.
                        </p>
                    </div>
                </div>
            </div>

            @if(isLoading) {
            <div class="col-12">
                <app-loading-box height="200"></app-loading-box>
            </div>
            } @else {
            <div class="col-12">
                <form [formGroup]="form">

                    <!-- Seção 1: Dados da Linha -->
                    <div class="row">
                        <div class="col-12">
                            <h2 class="subtitle-default">Dados da Linha</h2>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Descrição</mat-label>
                                <input matInput formControlName="descricao" maxlength="100"
                                    placeholder="Ex: Linha Industrial, Linha de Limpeza, Linha Básica" required>
                                @if (form.get('descricao')?.hasError('required')) {
                                <mat-error>A descrição é <strong>obrigatória</strong></mat-error>
                                }
                                @if (form.get('descricao')?.hasError('maxlength')) {
                                <mat-error>Máximo de <strong>100 caracteres</strong></mat-error>
                                }
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Seção 2: Configurações de Comissão -->
                    <div class="row mt-3">
                        <div class="col-12">
                            <h2 class="subtitle-default">Configurações de Comissão</h2>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <p class="comissao-label">Tipo de Comissão:</p>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="comissao-option">
                                <mat-checkbox formControlName="comissaoFixa" color="primary">
                                    Percentual de comissão fixa
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>

                    @if (isComissaoFixa) {
                    <div class="row mb-2">
                        <div class="col-md-4 col-12">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Comissão (%)</mat-label>
                                <input matInput type="text" formControlName="percentualComissao" placeholder="0,00"
                                    [currencyMask]="percentMask">
                            </mat-form-field>
                        </div>
                    </div>
                    }

                    <div class="row">
                        <div class="col-md-6 col-12">
                            <div class="comissao-option">
                                <mat-checkbox formControlName="comissaoConformeDescontos" color="primary">
                                    Comissão conforme descontos
                                </mat-checkbox>
                            </div>
                        </div>
                    </div>

                    <!-- Faixas de Comissão -->
                    @if (isComissaoDescontos) {
                    <div class="row">
                        <div class="col-12 discount-grid" formArrayName="faixasComissao">
                            <div class="d-flex justify-content-between align-items-center mb-2 mt-4">
                                <p>Faixas de Comissão</p>
                                <button type="button" mat-button (click)="addFaixaRow()"
                                    matTooltip="Adicionar nova faixa">
                                    <mat-icon>add</mat-icon> Adicionar
                                </button>
                            </div>

                            @for (item of faixasArray.controls; track item; let i = $index) {
                            <div [formGroupName]="i" class="discount-row-wrapper">
                                <div class="row w-100 g-2 align-items-center m-0">
                                    <div class="col-5 col-lg-5">
                                        <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                            class="w-100 no-bottom-space compact-input">
                                            <mat-label>Desconto de até (%)</mat-label>
                                            <input matInput formControlName="percentualDesconto" currencyMask
                                                [options]="percentMask" placeholder="0,00" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-5 col-lg-5">
                                        <mat-form-field appearance="outline" subscriptSizing="dynamic"
                                            class="w-100 no-bottom-space compact-input">
                                            <mat-label>Comissão (%)</mat-label>
                                            <input matInput formControlName="percentualComissao" currencyMask
                                                [options]="percentMask" placeholder="0,00" />
                                        </mat-form-field>
                                    </div>
                                    <div class="col-2 col-lg-2 delete-col">
                                        <button type="button" mat-icon-button (click)="removeFaixaRow(i)"
                                            matTooltip="Remover">
                                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            }

                            @if (faixasArray.length === 0) {
                            <div class="empty-state-grid">Nenhuma faixa de comissão configurada.</div>
                            }
                        </div>
                    </div>
                    }

                </form>
            </div>
            }
        </div>
    </div>
</div>
<app-footer-action [isLoadingSalvar]="isSaving" [isSalvarDisabled]="isLoading" (cancelar)="voltar()"
    (salvar)="salvar()"></app-footer-action>